import { render, staticRenderFns } from "./MegaMenu.vue?vue&type=template&id=bad7a8dc&"
import script from "./MegaMenu.vue?vue&type=script&lang=js&"
export * from "./MegaMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bad7a8dc')) {
      api.createRecord('bad7a8dc', component.options)
    } else {
      api.reload('bad7a8dc', component.options)
    }
    module.hot.accept("./MegaMenu.vue?vue&type=template&id=bad7a8dc&", function () {
      api.rerender('bad7a8dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/MegaMenu.vue"
export default component.exports